import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import EditUser from "./components/EditUser";
import Login from "./components/Login";
import Profile from "./components/Profile";
import Settings from "./components/Settings";
import DashboardLayout from "./components/DashboardLayout";
import DashboardHome from "./components/DashboardHome";
import Passbook from "./components/Passbook";
import CylinderMaster from "./components/CylinderMaster"; 
import ChallanForm from "./components/ChallanForm";
import InsertProduct from "./components/InsertProduct";
import DeliveredChallan from "./components/DeliveredChallan";
import ReceivedChallan from "./components/ReceivedChallan";
import ViewChallan from "./components/ViewChallan";
import CreateCustomer from "./components/CreateCustomer";
import ViewCustomer from "./components/ViewCustomer";
import CustomerDetails from "./components/CustomerDetails";
import CreateUser from "./components/CreateUser";
import ViewUser from "./components/ViewUser";
import GoodsDetails from "./components/GoodsDetails";
import "bootstrap-icons/font/bootstrap-icons.css";
import "bootstrap/dist/css/bootstrap.min.css";


// import './components/Sidebar';
// import './components/Header';
import ViewPassbook from "./components/ViewPassbook";
import Goods from "./components/Goods";
import { TokenManager } from "./utils/tokenManager";
import "./style/global-theme.css";
/* ✅ ADD THIS */
const isAuthenticated = () => {
  return TokenManager.getToken() !== null;
};

const App = () => {
  return (
    <BrowserRouter>
      <Routes>

        {/* Redirect root */}
        <Route path="/" element={<Navigate to="/login" />} />
      

        {/* Public */}
        <Route path="/login" element={<Login />} />

        {/* Protected Dashboard */}
        <Route
          path="/dashboard"
          element={
            isAuthenticated() ? <DashboardLayout /> : <Navigate to="/login" />
          }
        >
          <Route index element={<DashboardHome />} />
          
          <Route path="profile" element={<Profile />} />
          <Route path="settings" element={<Settings />} />
          <Route path="Passbook" element={<Passbook />} />
          <Route path="ViewPassbook" element={<ViewPassbook />} />
          <Route path="goods" element={<Goods />} />
         <Route path="cylinders" element={<CylinderMaster />} /> {/* ✅ route path */}
         <Route path="challan/delivered" element={<DeliveredChallan />} /> {/* ✅ Delivered Challan route */}
         <Route path="challan/received" element={<ReceivedChallan />} /> {/* ✅ Received Challan route */}
         <Route path="insert-products" element={<InsertProduct />} /> {/* ✅ Insert Product route */}
         <Route path="view-challan" element={<ViewChallan />} /> {/* ✅ View Challan route */}
         <Route path="challan/edit/:id" element={<ChallanForm />} /> {/* ✅ Edit Challan route */}
         <Route path="customers/create" element={<CreateCustomer />} /> {/* ✅ Create Customer route */}
         <Route path="customers/view" element={<ViewCustomer />} /> {/* ✅ View Customer route */}

         <Route path="customers/goods/:id" element={<GoodsDetails />} /> {/* Goods Details route */}
         <Route path="customers/:id" element={<CustomerDetails />} /> {/* Customer Details route */}
         <Route path="customers/passbook/:id" element={<ViewPassbook />} /> {/* View Passbook route */}
         <Route path="create-user" element={<CreateUser />} /> {/* Create User route */}
         <Route path="view-users" element={<ViewUser />} /> {/* View Users route */}
         <Route path="edit-user/:id" element={<EditUser />} /> {/* Edit User route */}
        </Route>

      </Routes>
    </BrowserRouter>
  );
};

export default App;
